import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import HouseList from "../components/houses/HouseList";
import HeroHome from "../components/homepage/HeroHome";
import ServicesHome from "../components/homepage/ServicesHome";
import Recents from "../components/homepage/Recents";
import Contact from "../components/homepage/contact";
import { IconBrandWhatsapp } from "@tabler/icons-react";

const Home = () => {
  return (
    <div>
      <Navbar />
      <HeroHome />
      <Recents />
      <ServicesHome />
      <Contact />
      <div className="wpp-main-icon">
        <a
          target="_blank"
          rel="noreferrer"
          href="http://wa.me/+573003672012?text=Me interesa una propiedad o servicio"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-brand-whatsapp"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9" />
            <path d="M9 10a.5 .5 0 0 0 1 0v-1a.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a.5 .5 0 0 0 0 -1h-1a.5 .5 0 0 0 0 1" />
          </svg>
        </a>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
